import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import { Modal } from 'components'
import { FlagForm } from '../forms'

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitFail: PropTypes.func.isRequired,
  title: PropTypes.string,
  reasonLabel: PropTypes.string,
  submitLabel: PropTypes.string,
}

const defaultProps = {
  title: 'Flag as Inappropriate',
  reasonLabel: null,
  submitLabel: null,
}

function FlagModal({ title, reasonLabel, submitLabel, ...formProps }) {
  return (
    <Modal
      onClose={formProps.onClose}
      hideCloseButton={true}
      shouldCloseOnOverlayClick={false}
    >
      <h2>{title}</h2>
      <FlagForm
        reasonLabel={reasonLabel}
        submitLabel={submitLabel}
        {...formProps}
      />
    </Modal>
  )
}

FlagModal.propTypes = propTypes
FlagModal.defaultProps = defaultProps

export default pure(FlagModal)
